export default __webpack_public_path__ + "media/images/contact-dog-hands-e8c315d5cc0ea13c56f2f8545d24d881.svg";